// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TMapGetBboxRequest, TMapGetBboxModel, IMappers, TMapGetBboxResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV2MapGetBBoxResponseSchema } from '../../../entities/get_bbox/V2MapGetBBoxResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createMapGetBboxModel(parameters: TMapGetBboxRequest): TMapGetBboxModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'search-offers-index',
    pathApi: '/v2/map/get-bbox/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IMapGetBboxOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TMapGetBboxRequest;
}

export async function fetchMapGetBbox<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IMapGetBboxOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TMapGetBboxResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createMapGetBboxModel(parameters),
    config,
  )) as FetchResponse<TMapGetBboxResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV2MapGetBBoxResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TMapGetBboxResponse>;
}
